import countries from 'assets/countries.json';
import country from 'country-list-js';

export const getCountryList = (language) => {
  const countryNames = country.names().sort();
  const setCountriesList = language === 'en' ? countryNames : countries;
  return setCountriesList;
};
